import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ToastState {
  message: string;
  error: boolean;
}

const initialState: ToastState = {
  message: '',
  error: false,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<{ message: string; error?: boolean }>) => {
      state.message = action.payload.message;
      state.error = action.payload.error ?? false;
    },
    clearToast: (state) => {
      state.message = '';
      state.error = false;
    },
  },
});

export const { showToast, clearToast } = toastSlice.actions;
export default toastSlice.reducer;
